export default __webpack_public_path__ + "static/media/brice.dd17b1f1.jpg";